// extracted by mini-css-extract-plugin
export default {"container":"style_container__kR9Hc","content":"style_content__Vq27f"};